{
	"name": "accountportal",
	"version": "1.0.19",
	"engines": {
		"node": ">=20.19.1",
		"npm": ">=10.8.2"
	},
	"scripts": {
		"ng": "ng",
		"start": "ng serve -c=\"dev\" -o",
		"start:bs": "ng serve -c=\"dev\" -o --host 0.0.0.0",
		"build": "ng build",
		"build:prod": "ng build --configuration=production",
		"test": "jest",
		"test:ci": "jest --ci",
		"lint": "ng lint",
		"doc": "npx compodoc -p tsconfig.json",
		"doc:serve": "npx compodoc -p tsconfig.json --toggleMenuItems -t -s",
		"format:check": "npx prettier --check \"src/**/*.{ts,html,scss,json,js}\"",
		"format:fix": "npx prettier --write \"src/**/*.{ts,html,scss,json,js}\"",
		"pre-commit-check": "ng lint --fix --exclude src/locale-data && npx pretty-quick --staged",
		"code-coverage": "ng test --code-coverage=true --watch=true",
		"prepare": "husky install",
		"gulp:bugsnag": "gulp bugsnagSourcemaps",
		"docker:build": "docker build -t accountportal .",
		"docker:up": "docker-compose up",
		"docker:health": "docker-compose -f docker-compose.health.yml up",
		"docker:cypress": "docker-compose -f docker-compose.cypress.yml up",
		"prod": "env STACK=\"dev-na2\" docker-compose up",
		"dev-sf": "env STACK=\"dev-sf\" docker-compose -f docker-compose.dev.yml up",
		"dev-cf": "env STACK=\"dev-cf\" docker-compose -f docker-compose.dev.yml up",
		"dev-na": "env STACK=\"dev-na\" docker-compose -f docker-compose.dev.yml up",
		"dev-na2": "env STACK=\"dev-na2\" docker-compose -f docker-compose.dev.yml up",
		"dev-na3": "env STACK=\"dev-na3\" docker-compose -f docker-compose.dev.yml up",
		"dev-eu": "env STACK=\"dev-eu\" docker-compose -f docker-compose.dev.yml up",
		"dev-oc": "env STACK=\"dev-oc\" docker-compose -f docker-compose.dev.yml up",
		"dev-meg-na": "env STACK=\"dev-meg-na\" docker-compose -f docker-compose.dev.yml up",
		"dev-meg-as": "env STACK=\"dev-meg-as\" docker-compose -f docker-compose.dev.yml up",
		"dev-meg-eu": "env STACK=\"dev-meg-eu\" docker-compose -f docker-compose.dev.yml up",
		"test-sf": "env STACK=\"test-sf\" docker-compose -f docker-compose.dev.yml up",
		"test-cf": "env STACK=\"test-cf\" docker-compose -f docker-compose.dev.yml up",
		"test-na": "env STACK=\"test-na\" docker-compose -f docker-compose.dev.yml up",
		"test-na2": "env STACK=\"test-na2\" docker-compose -f docker-compose.dev.yml up",
		"test-na3": "env STACK=\"test-na3\" docker-compose -f docker-compose.dev.yml up",
		"test-eu": "env STACK=\"test-eu\" docker-compose -f docker-compose.dev.yml up",
		"test-oc": "env STACK=\"test-oc\" docker-compose -f docker-compose.dev.yml up",
		"test-meg-na": "env STACK=\"test-meg-na\" docker-compose -f docker-compose.dev.yml up",
		"test-meg-as": "env STACK=\"test-meg-as\" docker-compose -f docker-compose.dev.yml up",
		"test-meg-eu": "env STACK=\"test-meg-eu\" docker-compose -f docker-compose.dev.yml up",
		"stg-sf": "env STACK=\"stg-sf\" docker-compose -f docker-compose.dev.yml up",
		"stg-cf": "env STACK=\"stg-cf\" docker-compose -f docker-compose.dev.yml up",
		"stg-na": "env STACK=\"stg-na\" docker-compose -f docker-compose.dev.yml up",
		"stg-na2": "env STACK=\"stg-na2\" docker-compose -f docker-compose.dev.yml up",
		"stg-na3": "env STACK=\"stg-na3\" docker-compose -f docker-compose.dev.yml up",
		"stg-eu": "env STACK=\"stg-eu\" docker-compose -f docker-compose.dev.yml up",
		"stg-oc": "env STACK=\"stg-oc\" docker-compose -f docker-compose.dev.yml up",
		"stg-meg-na": "env STACK=\"stg-meg-na\" docker-compose -f docker-compose.dev.yml up",
		"stg-meg-as": "env STACK=\"stg-meg-as\" docker-compose -f docker-compose.dev.yml up",
		"stg-meg-eu": "env STACK=\"stg-meg-eu\" docker-compose -f docker-compose.dev.yml up",
		"prod-sf": "env STACK=\"sf\" docker-compose -f docker-compose.dev.yml up",
		"prod-cf": "env STACK=\"cf\" docker-compose -f docker-compose.dev.yml up",
		"prod-na": "env STACK=\"na\" docker-compose -f docker-compose.dev.yml up",
		"prod-na2": "env STACK=\"na2\" docker-compose -f docker-compose.dev.yml up",
		"prod-na3": "env STACK=\"na3\" docker-compose -f docker-compose.dev.yml up",
		"prod-eu": "env STACK=\"eu\" docker-compose -f docker-compose.dev.yml up",
		"prod-oc": "env STACK=\"oc\" docker-compose -f docker-compose.dev.yml up",
		"prod-meg-na": "env STACK=\"meg-na\" docker-compose -f docker-compose.dev.yml up",
		"prod-meg-as": "env STACK=\"meg-as\" docker-compose -f docker-compose.dev.yml up",
		"prod-meg-eu": "env STACK=\"meg-eu\" docker-compose -f docker-compose.dev.yml up"
	},
	"private": true,
	"dependencies": {
		"@adyen/adyen-web": "^5.33.0",
		"@angular/animations": "^18.0.6",
		"@angular/cdk": "^18.0.6",
		"@angular/common": "^18.0.6",
		"@angular/compiler": "^18.0.6",
		"@angular/core": "^18.0.6",
		"@angular/forms": "^18.0.6",
		"@angular/material": "18.0.6",
		"@angular/platform-browser": "^18.0.6",
		"@angular/platform-browser-dynamic": "^18.0.6",
		"@angular/router": "^18.0.6",
		"@bugsnag/core": "^7.25.0",
		"@bugsnag/js": "^7.25.0",
		"@bugsnag/plugin-angular": "^7.25.0",
		"@material/menu": "^13.0.0",
		"@ngrx/effects": "^18.0.1",
		"@ngrx/router-store": "^18.0.1",
		"@ngrx/store": "^18.0.1",
		"@ngrx/store-devtools": "^18.0.1",
		"@webcomponents/custom-elements": "^1.5.0",
		"accesso-model-lib": "^1.20.0",
		"ajv": "^8.8.2",
		"dayjs": "1.11.10",
		"guest-app-ui": "^2.155.0",
		"lodash-es": "^4.17.15",
		"material-components-web": "^13.0.0",
		"rxjs": "^7.0.0",
		"tslib": "^2.0.0",
		"zone.js": "0.14.10"
	},
	"devDependencies": {
		"@angular/build": "^18.2.19",
		"@angular/cli": "^18.0.7",
		"@angular/compiler-cli": "^18.0.6",
		"@babel/preset-env": "^7.19.4",
		"@types/core-js": "^2.5.5",
		"@types/googlepay": "^0.5.2",
		"@types/jest": "^29.5.5",
		"@types/lodash-es": "^4.17.5",
		"@types/node": "20.17.32",
		"bugsnag-sourcemaps": "^1.3.0",
		"cldr": "^6.1.1",
		"cldr-data": "^36.0.1",
		"cldrjs": "^0.5.1",
		"codelyzer": "^6.0.2",
		"gulp": "^4.0.2",
		"gulp-babel": "^8.0.0",
		"gulp-replace": "^1.0.0",
		"gulp-sourcemaps": "^2.6.5",
		"gulp-uglify": "^3.0.2",
		"husky": "^8.0.1",
		"jest": "^29.7.0",
		"jest-marbles": "^3.0.5",
		"jest-preset-angular": "^14.1.1",
		"lint-staged": "^11.2.5",
		"prettier": "2.4.1",
		"ts-node": "~10.9.1",
		"tslint": "~6.1.3",
		"typescript": "5.4.5"
	},
	"lint-staged": {
		"*.{ts,scss,js,css,md,json}": "prettier --write"
	}
}
